"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var editable_text_scenario_node_component_1 = require("../editable-text-scenario-node/editable-text-scenario-node.component");

var scenario_state_1 = require("../../redux/scenario/scenario.state");

var variable_text_editor_container_1 = __importDefault(require("../variable-text-editor/variable-text-editor.container"));

var add_text_scenario_node_modal_style_1 = require("./add-text-scenario-node-modal.style");

var custom_modal_component_1 = __importDefault(require("../../common-components/custom-modal/custom-modal.component"));

var action_row_styles_1 = require("../action-row/action-row.styles");

var TextFields_1 = __importDefault(require("@material-ui/icons/TextFields"));

var gallery_card_component_1 = __importDefault(require("../../common-components/gallery-card/gallery-card.component"));

var text_scenario_node_container_1 = __importDefault(require("../text-scenario-node/text-scenario-node.container"));

var emptyNode = {
  header: "",
  options: [],
  type: scenario_state_1.ScenarioNodeType.Text
};

var AddTextScenarioNodeOverlay = function AddTextScenarioNodeOverlay(_ref) {
  var modalProps = _ref.modalProps,
      handleSave = _ref.handleSave;
  var handleClose = modalProps.handleClose;
  return react_1.default.createElement(custom_modal_component_1.default, Object.assign({}, modalProps), react_1.default.createElement(add_text_scenario_node_modal_style_1.StyledAddTextNodeModalContent, null, react_1.default.createElement(add_text_scenario_node_modal_style_1.StyledAddTextNodeModalTitle, null, react_1.default.createElement(action_row_styles_1.ActionIconWrapperDiv, null, react_1.default.createElement(TextFields_1.default, null)), "\u65B0\u898F\u30C6\u30AD\u30B9\u30C8\u3075\u304D\u3060\u3057\u4F5C\u6210"), react_1.default.createElement(gallery_card_component_1.default, null, react_1.default.createElement(add_text_scenario_node_modal_style_1.StyledAddTextNodeWrapperDiv, null, react_1.default.createElement(add_text_scenario_node_modal_style_1.StyledAddTextNodeDiv, null, react_1.default.createElement(text_scenario_node_container_1.default, {
    node: emptyNode
  }), react_1.default.createElement(variable_text_editor_container_1.default, {
    rawText: "",
    onSave: function onSave(rawText) {
      handleSave(rawText);
      handleClose();
    },
    onOverlayClick: handleClose,
    validate: editable_text_scenario_node_component_1.isValidHeader
  }))))));
};

exports.default = AddTextScenarioNodeOverlay;